@use "variables" as *;

.title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.section {
  margin-left: $spacing-m;
  margin-right: $spacing-m;
  margin-bottom: $spacing-m;
}

.avatar {
  width: 100%;
  height: 100%;
}

.publicCollectionsCard {
  padding: $spacing-m;
  margin: $spacing-m;
}

.collectionsTitle {
  margin-top: $spacing-xl;
  margin-left: $spacing-l;
  font-size: $fontSize-m;
  font-weight: bold;
}
